import { createContext, useContext } from 'react';

import type { Partner } from 'src/shared/constants';

type PartnerContext = Partner | null;

const defaultValue = null;

const context = createContext<PartnerContext>(defaultValue);
const { Provider } = context;

const usePartner = () => useContext(context);

export { usePartner, Provider };
